import { render, staticRenderFns } from "./questionType10.vue?vue&type=template&id=3785bc63"
import script from "./questionType10.vue?vue&type=script&lang=js"
export * from "./questionType10.vue?vue&type=script&lang=js"
import style0 from "./questionType10.vue?vue&type=style&index=0&id=3785bc63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports